'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function ($rootScope, $debounce) {
  // TODO : make x & y work
  var onWindowResize = $debounce(function () {
    $rootScope.$broadcast("$resize", {
      x: true,
      y: true
    });
  }, 100, false);
  $(window).on("resize", function () {
    $rootScope.$apply(function () {
      onWindowResize();
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/events/windowResize.js
// module id = 2698
// module chunks = 13